import { Flex, useColorModeValue, Button } from '@chakra-ui/react';
import { LanguageSwitchProps } from '../../../types/languageTypes';

const LanguageSelector: React.FC<LanguageSwitchProps> = ({
  selectedLanguage,
  onLanguageChange,
}) => {
  const buttons = [
    { lang: 'AR', label: 'عربي' },
    { lang: 'EN', label: 'English' },
  ];

  return (
    <Flex
      bg="#EDEDED"
      borderRadius="full"
      py="0.4rem"
      align="center"
      justify="center"
      w="13rem"
      style={{ direction: 'ltr' }}
      fontWeight="bold"
    >
      {buttons.map(({ lang, label }) => (
        <Button
          key={lang}
          onClick={() => onLanguageChange(lang as 'AR' | 'EN')}
          variant="unstyled"
          bg={
            selectedLanguage === lang
              ? 'linear-gradient(90deg, #6A23C1 0%, #D40D69 50%, #F39A3E 100%)'
              : 'transparent'
          }
          color={selectedLanguage === lang ? 'white' : 'black'}
          p="1.25rem"
          minW="6rem"
          fontSize="0.9rem"
          h="1.9rem"
          borderRadius="full"
          _hover={{
            bg:
              selectedLanguage === lang
                ? 'linear-gradient(90deg, #6A23C1 0%, #D40D69 50%, #F39A3E 100%)'
                : 'transparent',
          }}
          style={{ order: lang === 'AR' ? 0 : 1 }}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          {label}
        </Button>
      ))}
    </Flex>
  );
};

export default LanguageSelector;
